import React, { useEffect } from 'react';

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

const Loading = () => {
  const { isOpen } = useSelector((state) => state.common.loading);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('h-screen');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div data-testid="loading" id="loading" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-max">
      <div className="w-26 h-26 rounded-lg bg-white flex-middle-center">
        <img className="animate-spin" src={require('assets/resources/Loading.png')} alt="loading" width={72} height={72} />
      </div>
    </div>,
    document.body
  );
};

export default React.memo(Loading);
